import { createFileRoute } from "@tanstack/react-router";
import { Pulse } from "@/components/University/pulse/Pulse";

export const Route = createFileRoute("/_authenticated/atlas/pulse/")({
  component: Pulse,
  staticData: { page: "pulse" },
});
